// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1vxFB","rootCenter":"LoadMoreObserver_rootCenter__UX4e7","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3Y68K"};